var React = require('react');

function Wait (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M1.4 9a7.6 7.6 0 1 0 15.2 0A7.6 7.6 0 0 0 1.4 9M18 9A9 9 0 1 1 0 9a9 9 0 0 1 18 0M8.551 3h1.5v6.378l-4.273 2.591L5 10.687l3.551-2.154z"}));
}

Wait.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Wait;

Wait.default = Wait;
